import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin-left: 13px;
    margin-top: -4px;
    color: #9696b9;
    font-weight: var(--bold-font-weight);
    font-size: var(--s-font-size);
    text-transform: uppercase;
    opacity: 0.5;

    @media (max-width: ${DEVICE.laptop}) {
      font-size: var(--l-font-size);
    }
  }
`;
